import getColor from "@insite/mobius/utilities/getColor";
import { headerStyles as globalHeader } from "@waytek/Overrides/Pages/Header";
import { colorStrings, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

globalHeader.page = {
    fullWidth: [true, true, true, true, true],
    css: css`
        [data-zone="true"] {
            height: auto;
        }
    `,
};

globalHeader.container = {
    css: css`
        background-color: ${getColor(colorStrings.primaryMain)};
        border-top: 2px solid ${getColor(colorStrings.commonGlobalIndustrialTaupe)};
        display: flex;
        justify-content: center;

        > div:first-child {
            flex-grow: 1;
            max-width: 1090px;
            padding: 0 10px 0 20px;

            ${mediaQueriesBP.maxMD} {
                max-width: 1140px;
            }
        }

        > div:last-child {
            max-width: 150px;
            display: flex;
            align-items: center;
            justify-content: end;
            height: auto;
            padding: 0 20px 0 10px;

            ${mediaQueriesBP.maxMD} {
                max-width: 100px;
            }

            ${mediaQueriesBP.minLG} {
                padding: 0 30px 0 10px;
            }
        }
    `,
};

globalHeader.breadcrumbWrapper = {
    css: css`
        margin: auto;
        max-width: 1220px;
        padding: 10px 30px;

        ${mediaQueriesBP.maxMD} {
            padding: 10px 20px;
        }

        @media screen and (min-width: 1220px) {
            padding: 10px 20px;
        }
    `,
};
